/* ==========================================================================
   COURSE UNITS TABLE — search, filter, render
   Data comes from course-catalog.js. Progressive: if the data file fails to
   load, the section explains itself rather than showing an empty table.
   ========================================================================== */
(function () {
  'use strict';

  function boot() {
    var root = document.querySelector('[data-cu-school]');
    if (!root) return;

    var key = root.getAttribute('data-cu-school');
    var CAT = window.TMOC_CATALOG || {};
    var school = CAT[key];

    var body = root.querySelector('#cu-body');
    var empty = root.querySelector('#cu-empty');
    var count = root.querySelector('#cu-count');
    var search = root.querySelector('#cu-search');
    var deptSel = root.querySelector('#cu-dept');
    var lvlSel = root.querySelector('#cu-level');
    var reset = root.querySelector('#cu-reset');

    if (!school) {
      root.querySelector('#cu-lede').textContent =
        'Tell us your course code and we will confirm cover within the hour — we work across far more institutions than we list.';
      var wrap = root.querySelector('.cu__tablewrap');
      if (wrap) wrap.style.display = 'none';
      var ctl = root.querySelector('.cu__controls');
      if (ctl) ctl.style.display = 'none';
      return;
    }

    /* headings */
    root.querySelector('#cu-title').textContent = school.name + ' — course units we cover';
    root.querySelector('#cu-lede').textContent =
      'These are individual course units, not degree programmes. Search by code, title or ' +
      'department to check your specific unit. Our specialists cover midterms, finals, ' +
      'discussion posts, weekly assignments and the full term.';
    var note = root.querySelector('#cu-note');
    if (note) note.textContent = school.note || '';
    var official = root.querySelector('#cu-official');
    if (official && school.url) {
      official.href = school.url;
      official.setAttribute('href', school.url);
    }

    var rows = school.courses || [];

    /* department filter options */
    var depts = [];
    rows.forEach(function (r) { if (depts.indexOf(r[2]) === -1) depts.push(r[2]); });
    depts.sort();
    depts.forEach(function (d) {
      var o = document.createElement('option');
      o.value = d; o.textContent = d;
      deptSel.appendChild(o);
    });

    var LEVEL = { UG: 'Undergraduate', GR: 'Graduate', DOC: 'Doctoral' };

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function highlight(text, term) {
      if (!term) return esc(text);
      var i = text.toLowerCase().indexOf(term);
      if (i === -1) return esc(text);
      return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + term.length)) +
        '</mark>' + esc(text.slice(i + term.length));
    }

    function render() {
      var term = (search.value || '').trim().toLowerCase();
      var dept = deptSel.value;
      var lvl = lvlSel.value;

      var out = rows.filter(function (r) {
        if (dept && r[2] !== dept) return false;
        if (lvl && r[3] !== lvl) return false;
        if (!term) return true;
        /* Match on code with or without its separator, so "NR283",
           "NR-283" and "nr 283" all find the same unit. */
        var codeLoose = r[0].toLowerCase().replace(/[\s\-]/g, '');
        var termLoose = term.replace(/[\s\-]/g, '');
        return r[0].toLowerCase().indexOf(term) > -1 ||
          codeLoose.indexOf(termLoose) > -1 ||
          r[1].toLowerCase().indexOf(term) > -1 ||
          r[2].toLowerCase().indexOf(term) > -1;
      });

      body.innerHTML = out.map(function (r) {
        var q = encodeURIComponent(r[0] + ' ' + r[1] + ' (' + school.name + ')');
        return '<tr>' +
          '<td class="cu__code">' + highlight(r[0], term) + '</td>' +
          '<td class="cu__name">' + highlight(r[1], term) + '</td>' +
          '<td class="cu__dept">' + highlight(r[2], term) + '</td>' +
          '<td><span class="cu__lvl cu__lvl--' + r[3].toLowerCase() + '">' +
            (LEVEL[r[3]] || r[3]) + '</span></td>' +
          '<td class="cu__act">' +
            '<a class="cu__btn" href="/pages/order-now?service=onlineclass&amp;course=' + q + '">Get help</a>' +
          '</td>' +
        '</tr>';
      }).join('');

      empty.hidden = out.length > 0;
      count.textContent = out.length === rows.length
        ? 'Showing all ' + rows.length + ' listed units'
        : 'Showing ' + out.length + ' of ' + rows.length + ' units';
    }

    var t = null;
    search.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(render, 120);
    });
    deptSel.addEventListener('change', render);
    lvlSel.addEventListener('change', render);
    reset.addEventListener('click', function () {
      search.value = ''; deptSel.value = ''; lvlSel.value = '';
      render();
      search.focus();
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
